/**
 * TanStack Router: /performance/radar (Layout)
 *
 * Shared layout for all radar routes.
 * Provides RadarLayout with search modal and navigation.
 *
 * @see packages/web-apps/monutrack/docs/PERFORMANCE-RADAR-frontend-spec.md
 */
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { RadarLayout } from '@/components/performance/radar/RadarLayout'

/**
 * Route: /performance/radar
 * Layout: _auth (authenticated)
 * Component: RadarLayout wrapper with Outlet
 */
export const Route = createFileRoute('/_auth/performance/radar')({
  component: () => (
    <RadarLayout>
      <Outlet />
    </RadarLayout>
  ),
})
